import {
  FlowMessengerAction,
  SubflowMessengerAction,
} from 'lib-shared-types-api';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { FlowMessengerNodeSubflowReference } from 'components/settings/components/sections/dixaMessenger/views/flow/flow.types';
import { FlowT } from 'hocs/flows/api/types';

export function getReferencesToCurrentSubflow(
  subflowId: string,
  mainFlow: FlowT<FlowMessengerAction, SubflowMessengerAction>,
): FlowMessengerNodeSubflowReference[] {
  return (
    mainFlow?.actions?.filter(
      (action): action is FlowMessengerNodeSubflowReference =>
        action.nodeType === FlowNodeTypes.SUBFLOW_REFERENCE &&
        action.payload.subflowId === subflowId,
    ) ?? []
  );
}
